






























































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { WorkerDetailsModule } from '@/store/modules/workerDetails';
import WorkerDto from '@/models/Workers/WorkerDto';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateWorkerPermCurrentDetailsRequest from '@/models/Workers/UpdateWorkerPermCurrentDetailsRequest';

@Component({
    name: 'WorkerPermCurrentDetailsEdit'
})
export default class extends GiganautVueDialog {
 
  public dialog = false;
  public worker = new WorkerDto();
  
  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.worker = JSON.parse(JSON.stringify(WorkerDetailsModule.currentWorker));
      if (AgencySettingsModule.positions) {
        await AgencySettingsModule.getPositions();
      }
    }
  }

  get positions() {
    return AgencySettingsModule.positions;
  }

  get loading() {
    return WorkerDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateWorkerPermCurrentDetailsRequest()
    request.updatedAt = this.worker.updatedAt;
    request.currentAnnualSalary = this.worker.currentAnnualSalary;
    if (this.worker.currentPosition != null) {
      if (this.worker.currentPosition.id !== '') {
        request.currentPositionId = this.worker.currentPosition.id;
      }
    }
    await WorkerDetailsModule.editPermCurrentDetails(request);
    this.dialog = false;
  }
}
